import Slider from "../../components/slider/Slider";
import "react-tabs/style/react-tabs.css";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import ProductCarousel from "../../components/product/ProductCarousel";
import { memo, useEffect, useState } from "react";
import { getSliderRequest } from "../../services/sliders";
import Title from "../../components/title";
import BottomBox from "../../components/BottomBox";
import HomeNews from "../../components/home-news";
import HomeAbout from "../../components/home-about";
import ArticleHome from "../../components/ArticlesHome";
import AttachmentHome from "../../components/AttachmentHome";
import QuickAccess from "../../components/QuickAccess";
import styles from "./home.module.css";
const Home = memo(() => {
  let [sliders, setSliders] = useState([]);

  useEffect(() => {
    getSliderRequest().then(({ data }) => {
      setSliders((data && data.data) || []);
    });
  }, []);

  return (
    <div>
      <Title title={"صفحه اصلی"} />
      <QuickAccess />
      {sliders && sliders.length > 0 ? (
        <div id="slider">
          <Slider items={sliders} />
        </div>
      ) : (
        <div className={"slider-loading"}>
          <div className="loading-wrapper">
            <img
              src={"../../../assets/image/loading.svg"}
              alt={"در حال بار گذاری"}
            />
          </div>
        </div>
      )}
      <div id="about">
        <HomeAbout />
      </div>
      <div className={"container"}>
        <div id="product">
          <ProductCarousel />
        </div>
        <div className={"clearfix"}></div>
      </div>
      <div id="news">
        <HomeNews />
      </div>
      <div className="clearfix" />
      <div id="attachment-home">
        <AttachmentHome />
      </div>
      <div className="clearfix" />
      <div id="article-home">
        <ArticleHome />
      </div>
      <div className="clearfix" />
      <div className={styles.upFooterBg}>
        <BottomBox />
        <div className="clearfix" />
      </div>
    </div>
  );
});
export default Home;
